import { isConsultantNotActivePartnerBody } from '../services/ky-client/consultant-not-active-partner';
import { getHttpErrorBody, getHttpErrorStatus } from '../utils/error.utils';

export const DEFAULT_MAX_QUERY_RETRIES = 3; // TanStack Query's own default (`retry: 3`)

/** Deterministic block: retrying the request can only repeat the same 403. */
export function isConsultantNotActivePartnerError(error: unknown): boolean {
  return (
    getHttpErrorStatus(error) === 403 && isConsultantNotActivePartnerBody(getHttpErrorBody(error))
  );
}

/**
 * Client errors that a new attempt cannot change. A 403 is a missing permission
 * or add-on (in prod a tenant without the nutrition add-on collected 88
 * identical 403s in three minutes, DEV-398); the others are a malformed request,
 * an expired session, a missing or rejected resource. Retrying them only delays
 * the error message by ~7s of backoff (DEV-405). 408, 409 and 429 stay
 * retryable: they can succeed a moment later.
 */
const NON_RETRYABLE_STATUSES: ReadonlySet<number> = new Set([400, 401, 403, 404, 410, 413, 422]);

/** QueryClient-wide retry policy: TanStack's default budget, except for deterministic client errors. */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  const status = getHttpErrorStatus(error);
  if (status !== undefined && NON_RETRYABLE_STATUSES.has(status)) {
    return false;
  }
  return failureCount < DEFAULT_MAX_QUERY_RETRIES;
}
